import { render, staticRenderFns } from "./extraData.vue?vue&type=template&id=283fe1c9&"
import script from "./extraData.vue?vue&type=script&lang=js&"
export * from "./extraData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports